import React from 'react';
import css from './css.module.less';
import { get } from 'lodash';
import { useRequest } from 'ahooks';
import { SectionContainer } from 'src/components/Layouts';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import {
  //Form,
  Button,
  OriCheckbox,
  ModalFooter,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import { getCommunicationGateways } from 'src/request/settings/communication';
import { CommunicationGatewayProvider } from 'src/types/common/communication';
import Configuration from '@/src/components/Configuration/Configuration';
import ModalHoc from 'src/constrains/ModalHOC';
import {
  SectionContainer as Section,
  ModalContent,
} from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

//const Item = Form.Item;
const AutoPhoneNumberValidation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, modalOp } = props;

  const gatewayUuid = get(value, 'gatewayUuid');
  const enabled = get(value, 'enabled');

  const { setShowModal: sS, setModalTitle: sT, setModalContent: sC } = modalOp;

  const { data } = useRequest(() => {
    return getCommunicationGateways({
      params: { gatewayProvider: 'Twilio' },
    });
  });
  const twilio = (data || []).filter(
    (i) => i.gatewayProvider === CommunicationGatewayProvider.Twilio,
  );
  const handleOnSelectGateway = () => {
    sT(getI18n('salesChannelLocalisation.index.selectcommunicationgateways'));
    sC(
      <GatewaySelect
        data={twilio}
        value={gatewayUuid}
        onChange={handleOnSelectChange}
        onCancel={() => {
          sS(false);
        }}
      />,
    );
    sS(true);
  };
  const handleOnEnableChange = (e) => {
    const enabled = e.target.checked;
    const _v = { ...(value || {}), enabled };
    onChange(_v);
  };
  const handleOnSelectChange = (gatewayUuid) => {
    const _v = { ...(value || {}), gatewayUuid };
    onChange(_v);
    sS(false);
  };

  const currentTwilioName = get(
    twilio.find((i) => i.uuid === gatewayUuid),
    'name',
  );

  return (
    <SectionContainer className={css.container}>
      <ItemWrapper
        title={getI18n(
          'salesChannelLocalisation.index.autoPhoneNumberValidation',
        )}>
        {/* <Item
          shouldUpdate={(p, c) => {
            const pv = get(p, 'phoneAutoValidation');
            const cv = get(c, 'phoneAutoValidation');
            return pv != cv;
          }}>
          {(f) => {
            const { getFieldValue } = f;
              const gatewayUuid = get(value, 'gatewayUuid');
              const enabled = get(value, 'enabled');
            return <div>123</div>;
          }}
        </Item> */}
        <div>
          {getI18n(
            'salesChannelLocalisation.index.autoPhoneNumberValidationDesc',
          )}
        </div>
        {gatewayUuid && (
          <div style={{ paddingTop: 24 }}>{currentTwilioName} | Twilio</div>
        )}
      </ItemWrapper>
      <Button
        type='primary'
        className={css.button}
        disabled={twilio.length === 0}
        onClick={handleOnSelectGateway}>
        {getI18n('salesChannelLocalisation.index.selectTwolioGateway')}
      </Button>
      <OriCheckbox
        checked={enabled}
        onChange={handleOnEnableChange}
        className={css.checkbox}
        disabled={twilio.length === 0 || !!!gatewayUuid}>
        {getI18n('salesChannelLocalisation.index.selectTwolioGatewayLabel')}
      </OriCheckbox>
      <Configuration
        configStart={getI18n('salesChannelLocalisation.index.goto')}
        href={
          'https://www.twilio.com/docs/lookup/tutorials/validation-and-formatting'
        }
        configLink={getI18n('salesChannelLocalisation.index.twilioDocs')}
        configEnd={getI18n(
          'salesChannelLocalisation.index.toknowhowtouseLookupAPI',
        )}
      />
    </SectionContainer>
  );
};
export default ModalHoc(AutoPhoneNumberValidation);

const GatewaySelect = (props: any) => {
  const { data, value, onChange, onCancel } = props;
  const [select, setSelect] = React.useState(value);
  React.useEffect(() => {
    if (value !== select) {
      setSelect(value);
    }
  }, [value]);
  return (
    <React.Fragment>
      <ModalContent style={{ paddingTop: 0 }}>
        <Section style={{ paddingTop: 0, paddingBottom: 12 }}>
          <RadioGroup
            value={select}
            onChange={(e) => {
              const v = e.target.value;
              setSelect(v);
            }}
            className={css.radioGroup}>
            {(data || []).map((i) => {
              const { name, uuid } = i;
              return (
                <RadioItem value={uuid} key={uuid} className={css.radioItem}>
                  {name} | Twilio
                </RadioItem>
              );
            })}
          </RadioGroup>
        </Section>
      </ModalContent>
      <ModalFooter
        onCancel={onCancel}
        onOk={() => {
          onChange(select);
        }}
      />
    </React.Fragment>
  );
};
